import SaveIcon from '@mui/icons-material/Save';

export default function AdminPageDropDown({ heading, listitem }) {
  return (
    <div className="flex gap-3 flex-wrap">
      <div className=" bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-xl h-fit ">
        {heading}
      </div>
      <div className="flex gap-2 flex-wrap">
        <div>
          <select className="bg-[#F1F1F1] p-2 rounded-lg">
            <option value="option1">99214</option>
          </select>
        </div>
        <div>
          <select className="bg-[#F1F1F1] p-2 rounded-lg">
            <option value="option1">99214</option>
          </select>
        </div>
        <div>
          <select className="bg-[#F1F1F1] p-2 rounded-lg">
            <option value="option1">99214</option>
          </select>
        </div>
        <div className="w-[50px] h-[50px] rounded-full bg-gray-200 flex items-center justify-center">
          <SaveIcon className="text-teal-800" />
        </div>
      </div>
    </div>
  );
}
